import React from "react";
import logo from "../assets/logo.svg";
import { Link, useHistory } from "react-router-dom";
import { Box, Center, Flex, Text, Grid } from "@chakra-ui/react";
import RegisterForm from "./RegisterForm";
import { useAuth } from "../context/authContext";

const Register = () => {
  const auth = useAuth();
  const history = useHistory();

  const register = async (data) => {
    await auth
      .register(data)
      .then((res) => {
        history.push("/dashboard");
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  return (
    <Flex
      sx={{ minHeight: "100vh", width: "100%" }}
      justify="center"
      bg="#223D5D"
      py={8}
    >
      <Box>
        <Center>
          <Link to="/">
            <img height="126px" width="345px" src={logo} alt="logo" />
          </Link>
        </Center>

        <Grid
          bg="white"
          mt={6}
          sx={{
            maxWidth: "445px",
            minHeight: "447px",
            borderRadius: "10px",
            fontWeight: 510,
          }}
          gridTemplateAreas="'header' 'body' 'footer'"
          gridTemplateRows="auto 1fr auto"
        >
          <Box sx={{ gridArea: "body" }} pt="8">
            <RegisterForm register={register} />
          </Box>
          <Box
            bg="#F6F7F8"
            py={5}
            mt={8}
            gridArea="footer"
            sx={{
              textAlign: "center",
              borderRadius: "inherit",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Text mr="1">Have an account?</Text>
            <Link to="/login">
              <Text color="#00A2E8">Login</Text>
            </Link>
          </Box>
        </Grid>
      </Box>
    </Flex>
  );
};

export default Register;
